/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ObjectPropertiesDto } from './objectPropertiesDto';


export interface CreateMultiPartUploadDto { 
    objectProps: Array<ObjectPropertiesDto>;
}

